/**
 * PromoBlock
 * @module components/PromoBlock
 */

import React from 'react';
import {
	PromoBlockContent,
	ContentHeading,
	PromoButton,
} from './PromoBlock.styles';

import RichText from 'components/ui/RichText';

import { getHeadingLevel } from 'common/helpers';
import { useDispatch } from 'react-redux';
import { fetchConfArticle } from 'store/modules/configurator';
import { PromoBlockModel } from 'types/block-types';
import { BackgroundColorTypes } from 'types/common';
import clsx from 'clsx';
import { useSiteType } from 'context/siteType.context';
import Icon from 'components/ui/Icon';

export interface PromoContentModel extends PromoBlockModel {
	theme?: BackgroundColorTypes;
	imageOutside?: boolean;
	contentLeft?: boolean;
	fullWidth?: boolean;
	videoPreference?: string;
}

const PromoContent = (props: PromoContentModel) => {
	const {
		theme,
		imageOutside,
		contentLeft,
		heading,
		text,
		buttons,
		fullWidth,
		confArticle,
		toggleModal,
		headingLevel,
		headingStyleLevel,
		videoPreference,
		toggleImageGallery,
		toggleOnImage,
	} = props;

	const dispatch = useDispatch();
	const siteType = useSiteType();

	const handleClick = async (
		e: MouseEvent,
		url: string,
		index: number,
		imageGallery: any
	) => {
		try {
			if (confArticle && index === 0) {
				e.preventDefault();
				toggleModal && toggleModal();
				await dispatch(fetchConfArticle(url));
			}

			if (!toggleOnImage && toggleImageGallery && imageGallery) {
				e.preventDefault();
				toggleImageGallery();
			}
		} catch (err) {
			console.log(err);
		}
	};

	const headingCss =
		headingStyleLevel === 1
			? 'text-h2 md:text-h1'
			: `text-${getHeadingLevel(headingStyleLevel)}`;

	return (
		<PromoBlockContent
			videoPreference={videoPreference}
			theme={theme}
			outside={imageOutside}
			fullWidth={fullWidth}
			contentLeft={contentLeft}
			className="rounded-b-card md:rounded-card"
		>
			{heading && (
				<ContentHeading
					fullWidth={fullWidth}
					theme={theme}
					as={getHeadingLevel(headingLevel)}
					className={clsx(headingCss, siteType === 'Lindab' && 'font-bold')}
				>
					{heading}
				</ContentHeading>
			)}
			{text && (
				<RichText
					className={clsx(
						'text-p mb-6',
						siteType === 'Lindab' ? 'font-normal' : 'font-light',
						theme === 'lgGreen' || theme === 'lgBlueGray'
							? 'text-lgLightGrayBlue'
							: theme === 'blue'
							? 'text-white link-white'
							: 'text-black'
					)}
					text={text}
				/>
			)}
			{buttons && (
				<div
					className={clsx(
						siteType === 'LindabGroup' && fullWidth
							? 'flex md:absolute mt-4'
							: 'flex flex-wrap gap-2'
					)}
				>
					{buttons.map((button, i) => {
						return (
							<PromoButton
								key={`promobutton-${i}`}
								type={'link'}
								buttonColor={button.color}
								darkBackground={theme === 'blue'}
								url={button.link}
								styling={'button'}
								target={button.target}
								fullWidth={fullWidth}
								onClick={(e: MouseEvent) =>
									handleClick(e, button.link, i, button.imageGallery)
								}
							>
								{siteType === 'LindabGroup' && (
									<Icon icon="chevrons" direction="left" size={1.25} />
								)}
								<span>{button.text}</span>
								{siteType === 'Lindab' && <Icon icon="arrow" size={1.25} />}
							</PromoButton>
						);
					})}
				</div>
			)}
		</PromoBlockContent>
	);
};

export default PromoContent;
